import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

import FieldGroup from '../../../components/FieldGroup';

export const FooterLogoWrapper = styled.div`
  margin-top: ${gridSize}px;
`;

export const PrivacyPolicyContainer = styled.div`
  margin-top: ${gridSize()}px;
  text-align: left;
  padding-left: 0;
`;

export const SignUpButtonWrapper = styled.div`
  margin-top: ${gridSize()}px;
`;

export const Form = styled.form`
  margin: 0;
`;

export const EmailFieldGroup = styled(FieldGroup)`
  margin-bottom: ${gridSize()}px;
`;
